import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .logo--container {
    height: 2.1rem;
    margin-right: 3.2rem;
    margin-top: 5.2rem;
    width: 6.6rem;
  }
`;

export const MainContainer = styled.div`
  padding-top: 3rem;
`;
